import React, { useState, useEffect, useRef } from "react";
import Navbar from "components/Navbars/AuthNavbar";
import Footer from "components/Footers/Footer";
import Swal from "sweetalert2";
import BASE_URL from "components/BaseUrl/apiConfig";
import BlockUiOverlay from "components/Expense/BlockUiOverlay";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const Settings = () => {
  const [email, setEmail] = useState("");
  const [ccEmail, setCCEmail] = useState("");
  const [ccEmailReport, setCCEmailReport] = useState("");
  const [validationError, setValidationError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [currency, setCurrency] = useState("");
  const [loading, setLoading] = useState(true);
  const [emailAddresses, setEmailAddresses] = useState("");
  const [signature, setSignature] = useState("");
  const [imageInserted, setImageInserted] = useState(false);
  const [value, setValue] = useState("");

  const handleChange = (value) => {
    setSignature(value); // Value is the HTML content of the editor
  };
  //get userid form loca storage
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let userTypeId = "";
  let groupId = "";
  const quillRef = useRef(null);
  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    userTypeId = userData.userTypeId;
    groupId = userData.groupId;
  }

  useEffect(() => {
    if (quillRef.current) {
      const editor = quillRef.current.getEditor();
      // Use the editor instance if needed
    }
  }, []);

  // Fetch signature data from API
  useEffect(() => {
    const fetchSignatureData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Expense/GetSignature?userID=${userId}&groupID=${groupId}`
        );
        const data = await response.json();
        if (response.ok) {
          // Set the signature data to the editor
          setSignature(data.msg.signatureData);
        } else {
          console.error("Error fetching signature data:", data);
        }
      } catch (error) {
        console.error("Error fetching signature data:", error);
      }
    };

    fetchSignatureData();
  }, [userId, groupId]);

  // Fetch email addresses from API
  useEffect(() => {
    const fetchEmailAddresses = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Expense/GetEmailAddresses?groupId=${groupId}`
        );
        const data = await response.json();
        if (response.ok) {
          console.log("Fetched email addresses:", data.emails);
          setEmailAddresses(data.emails);
          setCCEmailReport(data.ccEmails || ""); // Use empty string if ccEmails is not provided
        } else {
          console.error("Error fetching email addresses:", data);
        }
      } catch (error) {
        console.error("Error fetching email addresses:", error);
      }
    };

    fetchEmailAddresses();
  }, [groupId]);

  useEffect(() => {
    // Fetch email address from the API
    const fetchEmail = async () => {
      try {
        const storedUserData = localStorage.getItem("userData");
        if (storedUserData) {
          const userData = JSON.parse(storedUserData);
          const userId = userData.userId;

          const response = await fetch(
            `${BASE_URL}/api/Settings/GetEmailforExpenseReport?userid=${userId}`
          );
          const data = await response.json();
          // Assuming the API response has an 'email' field, update the state
          setEmail(data.email);
          setCCEmail(data.ccEmail);
        }
      } catch (error) {
        console.error("Error fetching email:", error);
      }
    };

    fetchEmail();
  }, [userId]);

  useEffect(() => {
    const fetchCurrencyData = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`
        );
        const data = await response.json();
        // Assuming the API response has a property called 'currency'
        setCurrency(data.currency);
      } catch (error) {
        console.error("Error fetching currency data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCurrencyData();
  }, []); // The empty dependency array ensures that this effect runs only once when the component mounts

  const handleImageUpload = (file) => {
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      const range = quillRef.current.getEditor().getSelection();
      quillRef.current
        .getEditor()
        .insertEmbed(range.index, "image", reader.result);
      // Resize images after insertion
      const img = quillRef.current
        .getEditor()
        .root.querySelector('img[src="' + reader.result + '"]');
      if (img) {
        img.style.width = "200px";
        img.style.height = "50px";
      }
    };
    reader.readAsDataURL(file);
  };

  const handleSignatureSave = async () => {
    const editor = quillRef.current.getEditor();
    const images = editor.root.querySelectorAll("img");

    // Resize images
    images.forEach((img) => {
      img.style.width = "200px";
      img.style.height = "50px";
    });

    // Get the updated signature content
    const updatedSignature = editor.root.innerHTML;
    // Check if the signature is empty
    if (!updatedSignature || updatedSignature === "<p><br></p>") {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Signature cannot be empty. Please provide a valid signature.",
      });
      return;
    }
    console.log("Signature saved:", updatedSignature);
    try {
      // Retrieve userId and groupId from local storage
      const userData = JSON.parse(localStorage.getItem("userData"));
      const userId = userData?.userId;
      const groupId = userData?.groupId;

      if (!userId || !groupId) {
        throw new Error("User ID or Group ID is missing in local storage.");
      }

      // Show confirmation dialog
      const result = await Swal.fire({
        title: "Confirmation!",
        text: "Are you sure you want to save this signature?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Save",
      });

      if (result.isConfirmed) {
        // Add inline styles for line-height to the signature content
        const styledSignature = updatedSignature.replace(
          /<p>/g,
          '<p style="line-height: 1.2;">' // Set your desired line height here
        );
        // Prepare API request
        const response = await fetch(`${BASE_URL}/api/Expense/AddSignature`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userID: userId,
            groupID: groupId,
            signatureID: 0, // or provide the signature ID if available
            signatureData: styledSignature, // Save HTML content
            createdAt: new Date().toISOString(),
          }),
        });

        if (response.ok) {
          await Swal.fire({
            icon: "success",
            title: "Success",
            text: "Signature saved successfully!",
          });
        } else {
          throw new Error("Error saving signature");
        }
      }
    } catch (error) {
      console.error("Error saving signature:", error);
      Swal.fire({
        icon: "error",
        title: "Something went wrong.",
        text: error.message,
      });
    }
  };

  const handleUpdate = async () => {
    // Check if the selected currency is empty or null
    if (!currency) {
      // Display SweetAlert validation message
      Swal.fire({
        title: "Something went wrong.",
        text: "Please choose a currency",
        icon: "error",
      });
      return; // Do not proceed with the update
    }

    // Display SweetAlert confirmation dialog
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update the currency?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    });
    // If the user clicks on "Yes"
    if (result.isConfirmed) {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Users/UpdateCurrencybyUserId?userid=${userId}&Currency=${currency}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        // Check if the update was successful (status code 200)
        if (response.ok) {
          // Display SweetAlert success message with the API response
          Swal.fire({
            title: "Success",
            text: `Currency updated successfully.`,
            icon: "success",
          });
        } else {
          Swal.fire({
            title: "Error",
            text: `Failed to update currency. API Error Response:`,
            icon: "error",
          });
        }
      } catch (error) {
        Swal.fire({
          title: "Error",
          text: `Error updating currency: ${error.message}`,
          icon: "error",
        });
      }
    }
  };

  //here is the code of the button click
  // ... (existing code)

  const handleButtonClick = async () => {
    try {
      // Validation: Check if the email is valid
      // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const trimmedEmail = email.replace(/\s/g, ""); // Remove leading and trailing spaces from email
      const emailRegex =
        /^([^\s@]+@[^\s@]+\.[^\s@]+)(,[^\s@]+@[^\s@]+\.[^\s@]+)*$/;
      const trimmedccEmail = ccEmail.replace(/\s/g, "");
      if (!emailRegex.test(trimmedEmail)) {
        throw new Error("Please enter a valid email address.");
      }

      const actionText = email ? "update" : "insert";
      const result = await Swal.fire({
        title: "Confirmation!",
        text: `Are you sure you want to ${actionText} this email?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText:
          actionText.charAt(0).toUpperCase() + actionText.slice(1), // Capitalize the action text
      });

      if (result.isConfirmed) {
        const apiUrl = `${BASE_URL}/api/Settings/AddEmailforExpenseReport?email=${email}&userid=${userId}&ccEmail=${ccEmail}`;
        const response = await fetch(apiUrl, { method: "POST" });

        if (response.ok) {
          const actionPastTense = email ? "updated" : "inserted";
          await Swal.fire({
            icon: "success",
            title: "Success",
            text: `Email ${actionPastTense} successfully!`,
            showConfirmButton: true,
            onClose: () => {
              // Additional logic after the alert is closed
            },
          }); 
        } else {
          throw new Error("Error updating/inserting email");
        }
      }
    } catch (error) {
      console.error("Error updating/inserting email:", error);
      Swal.fire({
        icon: "error",
        title: "Something went wrong.",
        text: error.message,
      });
    }
  };

  // ... (existing code)

  const buttonText = email ? "Update" : "Save";

  const handleEmailButtonClick = async () => {
    // Reset the validation error
    setValidationError("");

    // Get the input values
    const emailAddresses = document.getElementById("sendMessagesReport").value;
    const ccEmailReport = document.getElementById("ccEmailReport").value || "";
    const groupId = JSON.parse(localStorage.getItem("userData")).groupId;

    // Simple validation check for the main email field
    if (!emailAddresses.trim()) {
      Swal.fire({
        title: "Validation Error!",
        text: "The 'Send Messages Report to' field cannot be empty.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    // Construct the URL with optional ccEmails parameter
    const url = `${BASE_URL}/api/Expense/AddEmailAddresses?groupId=${groupId}&emails=${encodeURIComponent(
      emailAddresses
    )}${ccEmailReport ? `&ccEmails=${encodeURIComponent(ccEmailReport)}` : ""}`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log("Emails added successfully:", data);

        // Show success alert
        Swal.fire({
          title: "Success!",
          text: "Email addresses for sending messages report have been added successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        const errorData = await response.json();
        console.error("Error adding emails:", errorData);

        // Show error alert
        Swal.fire({
          title: "Error!",
          text: "Failed to add email addresses.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error adding emails:", error);

      // Show error alert
      Swal.fire({
        title: "Error!",
        text: "Failed to add email addresses.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <>
      <Navbar />
      <div className="cust-div">
        <BlockUiOverlay visible={loading} />
        {/* Settings Section */}
        <div className="container mx-auto mt-5 p-4">
          <h1 className="text-2xl uppercase font-bold">Settings</h1>
        </div>

        <div className="container mx-auto p-4 flex flex-col md:flex-row gap-4">
          <div className="flex flex-grow items-center">
            <label
              htmlFor="expenseTypeEmail"
              className="block text-sm mr-3 uppercase font-medium text-gray-700 flex-shrink-0"
            >
              Send Expenses Report to
            </label>
            <input
              type="text"
              id="expenseTypeEmail"
              name="expenseTypeEmail"
              className="rounded flex-grow"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={userTypeId === 3}
            />
          </div>

          <div className="flex flex-grow items-center">
            <label
              htmlFor="ccEmail"
              className="block text-sm mr-3 uppercase font-medium text-gray-700 flex-shrink-0"
            >
              CC Email Address
            </label>
            <input
              type="text"
              id="ccEmail"
              name="ccEmail"
              className="rounded flex-grow"
              value={ccEmail}
              onChange={(e) => setCCEmail(e.target.value)}
              disabled={userTypeId === 3}
            />
          </div>

          {userTypeId !== 3 && (
            <div className="flex items-right">
              <button
                type="button"
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                onClick={handleButtonClick}
              >
                {email ? "Update" : "Save"}
              </button>
            </div>
          )}
        </div>

        <hr className="mb-1 mx-auto px-4 border-b-1 border-blueGray-200" />
        <div className="container mx-auto mt-8 p-4">
          <h1 className="text-2xl uppercase font-bold">Messages Reports</h1>
        </div>

        <div className="container mx-auto p-4">
          <form className="flex flex-col md:flex-row items-center gap-4">
            <div className="flex items-center flex-grow">
              <label
                htmlFor="sendMessagesReport"
                className="block text-sm mr-3 uppercase font-medium text-gray-700"
              >
                Send Messages Report to
              </label>
              <input
                type="text"
                id="sendMessagesReport"
                name="sendMessagesReport"
                className="rounded flex-grow"
                value={emailAddresses}
                onChange={(e) => setEmailAddresses(e.target.value)}
                disabled={userTypeId === 3}
              />
            </div>
            <div className="flex items-center flex-grow">
              <label
                htmlFor="ccEmailReport"
                className="block text-sm mr-3 uppercase font-medium text-gray-700"
              >
                CC Email Address
              </label>
              <input
                type="text"
                id="ccEmailReport"
                name="ccEmailReport"
                className="rounded flex-grow"
                value={ccEmailReport}
                onChange={(e) => setCCEmailReport(e.target.value)}
                disabled={userTypeId === 3}
              />
            </div>

            {userTypeId !== 3 && (
              <div className="flex items-right">
                <button
                  type="button"
                  className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                  onClick={handleEmailButtonClick}
                >
                  {emailAddresses ? "Update" : "Save"}
                </button>
              </div>
            )}
 
            {emailError && (
              <p className="text-red-500 text-xs italic mt-2 md:ml-4">
                {emailError}
              </p>
            )}
          </form>
        </div>

        {/* <hr className="mb-1 mx-auto px-4 border-b-1 border-blueGray-200" />
        <div className="container mx-auto mt-8 p-4">
          <h1 className="text-2xl uppercase font-bold">Email Signature</h1>
        </div>

        <div className="container mx-auto p-4">
          <ReactQuill
            ref={quillRef}
            value={signature}
            onChange={handleChange}
            style={{
              border: "1px solid #ddd",
              minHeight: "200px",
              maxHeight: "200px",
              overflow: "auto",
            }}
            modules={{
              toolbar: [
                [{ header: "1" }, { header: "2" }, { font: [] }],
                [{ size: [] }],
                ["bold", "italic", "underline", "strike", "blockquote"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["link", "image"],
                ["clean"],
              ],
            }}
            formats={[
              "header",
              "font",
              "size",
              "bold",
              "italic",
              "underline",
              "strike",
              "blockquote",
              "list",
              "bullet",
              "link",
              "image",
            ]}
            placeholder="Write your signature here..."
          />

          <div className="relative mt-6"> 
            <button
              type="button"
              style={{ marginTop: "60px" }}
              className="absolute top-0 right-0 mt-0 mr-0  bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
              onClick={handleSignatureSave}
            >
              Save Signature
            </button>
          </div>
        </div> */}

        <hr className="mb-1  mx-auto px-4 border-b-1 border-blueGray-200" />

        <div className="container mx-auto  p-4">
          <h1 className="text-2xl uppercase font-bold">Choose Currency</h1>
        </div>
        <div className="container mx-auto p-4 flex flex-col items-center">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <form className="flex items-center">
              <label
                htmlFor="expenseTypeName"
                className="block text-sm mr-3 flex uppercase font-medium text-gray-700"
              >
                Choose Currency
              </label>

              {userTypeId != 3 ? (
                <select
                  id="currency"
                  name="currency"
                  className="rounded"
                  value={currency}
                  onChange={(e) => setCurrency(e.target.value)}
                >
                  <option value="">Choose Currency</option>
                  <option value="INR">INR</option>
                  <option value="USD">US dollar</option>
                  <option value="Dinar">Dinar</option>
                  <option value="Euro">Euro</option>
                </select>
              ) : (
                <select
                  id="currency"
                  name="currency"
                  className="rounded"
                  value={currency}
                  onChange={(e) => setCurrency(e.target.value)}
                  disabled
                >
                  <option value="">Choose Currency</option>
                  <option value="INR">INR</option>
                  <option value="USD">US dollar</option>
                  <option value="Dinar">Dinar</option>
                  <option value="Euro">Euro</option>
                </select>
              )}

              {userTypeId != 3 ? (
                <button
                  type="button"
                  onClick={handleUpdate}
                  className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 ml-2"
                >
                  Update
                </button>
              ) : null}
            </form>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Settings;
